import moment from 'moment-timezone'

import { FormFieldValues } from './actionHooks'

import { convertToAssigneeInfo } from '@/components/form-components/AssigneeSelect'
import { StoredProject } from '@/context/projectContext'
import { FileUploadResult } from '@/hooks/useAttachmentUpload'
import { isProjectSelected } from '@/utils/index'

import {
  PlatformAction,
  PlatformActionStatus,
  ProjectStatus,
} from 'types/api.graphql'
import { AssigneeLike } from 'types/vagueTypes'

export const getNewInitialValues = (
  project: StoredProject,
  locationId?: string
): Partial<FormFieldValues> => {
  const projectId = isProjectSelected(project) ? project.id : null

  return {
    project: {
      id: projectId,
      name: project?.name,
      status: project?.status as ProjectStatus,
    },
    status: PlatformActionStatus.ToDo,
    location: locationId,
  }
}

type EditInitialValues = {
  type?: PlatformAction['type']
  title?: PlatformAction['title']
  description?: PlatformAction['description']
  status: PlatformAction['status']
  priorityType?: PlatformAction['priorityType']
  project?: {
    id: PlatformAction['project']['id']
    name: PlatformAction['project']['name']
    status: PlatformAction['project']['status']
  }
  attachments?: Array<{
    id: PlatformAction['attachments'][number]['id']
    key?: PlatformAction['attachments'][number]['key']
    url: PlatformAction['attachments'][number]['url']
    fileName: PlatformAction['attachments'][number]['fileName']
  }>
  dueDate?: string
  assignees?: AssigneeLike[]
  locationId?: PlatformAction['locationId']
  config?: PlatformAction['config']
}

export const getEditInitialValues = (
  action: EditInitialValues
): Partial<FormFieldValues> => {
  if (!action) return {}

  const { dueDate } = action

  const attachments = action.attachments?.map(
    (att) =>
      ({
        uid: att.id,
        attachmentId: att.id,
        key: att.key || att.id,
        url: att.url,
        name: att.fileName,
      }) as FileUploadResult
  )

  return {
    type: action.type,
    title: action.title,
    description: action.description,
    status: action.status,
    priorityType: action.priorityType,
    project: action.project,
    attachments,
    dueDate: dueDate ? moment(dueDate) : null,
    assignees: convertToAssigneeInfo(action.assignees),
    location: action.locationId,
    requireAttachment: action.config?.requireAttachmentToClose,
  }
}
